import Head from 'next/head';
import Post from 'src/views/Marketing/Blog/snippets/poshmark-cancel-sale';

export default function Example() {
  return (
    <>
      <Head>
        <title>How to Cancel an Order on Poshmark | OneShop Blog</title>
        <meta
          name='description'
          content='If you haven’t shipped an item yet, it’s still possible to cancel an order before it’s sent out! Here’s how to do it.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-cancel-sale' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-cancel-sale' />
        <meta property='og:title' content='How to Cancel an Order on Poshmark | OneShop Blog' />
        <meta
          property='og:description'
          content='If you haven’t shipped an item yet, it’s still possible to cancel an order before it’s sent out! Here’s how to do it.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2021-07-08T00:00:00.000Z' />
        <meta property='article:modified_time' content='2021-07-08T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
